import DOMPurify from "dompurify";
import { marked } from "marked";

// Agent output is untrusted (it quotes mail, chats and CRM text): render, then sanitise.
if (DOMPurify.isSupported) {
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A") {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
    }
  });
}

const escapeHtml = (s: string) =>
  s.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]!);

export function renderMarkdown(text: string): string {
  // DOMPurify returns its input unchanged when it can't sanitise: show plain text instead.
  if (!DOMPurify.isSupported) return `<p>${escapeHtml(text).replace(/\n/g, "<br>")}</p>`;
  const html = marked.parse(text, { async: false, gfm: true, breaks: true });
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true }, FORBID_TAGS: ["img", "style", "form", "input"] });
}
